import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDkeyHoldIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20.5 3H3.5C3.22386 3 3 3.22386 3 3.5V20.5C3 20.7761 3.22386 21 3.5 21H20.5C20.7761 21 21 20.7761 21 20.5V3.5C21 3.22386 20.7761 3 20.5 3Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDkeyHoldIcon.displayName = 'TimeDkeyHoldIcon';
